export default "__VITE_ASSET__BlfTOYWq__"